// Версия проекта: имя вида 5.4.4.50 (4 числовых сегмента)
export const VERSION_RE = /^\d{1,3}(\.\d{1,3}){3}$/;

export const isVersionName = (s) => VERSION_RE.test((s ?? '').trim());

// Числовое сравнение по сегментам (по возрастанию)
export const compareVersions = (a, b) => {
    const pa = (a ?? '').split('.').map(Number);
    const pb = (b ?? '').split('.').map(Number);
    const len = Math.max(pa.length, pb.length);
    for (let i = 0; i < len; i += 1) {
        const d = (pa[i] || 0) - (pb[i] || 0);
        if (d !== 0) return d;
    }
    return 0;
};

// Опции фильтра журнала: уникальные версии по убыванию,
// затем префиксы из 3 и 2 сегментов с меткой «.*»
export const versionFilterOptions = (versions) => {
    const names = [...new Set((versions ?? []).map((v) => v.name).filter(Boolean))]
        .sort(compareVersions)
        .reverse();
    const options = names.map((name) => ({ value: name, label: name }));
    for (const segments of [3, 2]) {
        const prefixes = [...new Set(
            names.map((name) => name.split('.').slice(0, segments).join('.')),
        )].sort(compareVersions).reverse();
        options.push(...prefixes.map((p) => ({ value: p, label: `${p}.*` })));
    }
    return options;
};
